document.addEventListener(
	'DOMContentLoaded',
	() => {
		window.addEventListener(
			'load',
			() => {
				if (
					typeof gsap === 'undefined' ||
					typeof ScrollTrigger === 'undefined' ||
					! document.body ||
					document.body.classList.contains( 'wp-admin' )
				) {
					return;
				}

				if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
					return;
				}

				gsap.registerPlugin( ScrollTrigger );

				const blocks = document.querySelectorAll( '.cirrus-trac-scroll-swipe' );

				if ( ! blocks.length ) {
					return;
				}

				let resizeTimer = 0;
				window.addEventListener( 'resize', () => {
					window.clearTimeout( resizeTimer );
					resizeTimer = window.setTimeout( () => {
						ScrollTrigger.refresh();
					}, 200 );
				} );

				/**
				 * Measure copy height at its final layout (bottom-left), then hide for the image phase.
				 *
				 * @param {HTMLElement} el
				 * @return {number} Pixel distance to translate down so the block sits fully out of view.
				 */
				const measureDescSlidePx = ( el ) => {
					gsap.set( el, { opacity: 1, y: 0, overwrite: 'auto' } );
					const px = Math.ceil( el.offsetHeight );
					gsap.set( el, { opacity: 0, y: 0, overwrite: 'auto' } );
					return Math.max( px, 1 );
				};

				blocks.forEach( ( root ) => {
					if ( root.getAttribute( 'data-tsw-no-animation' ) === '1' ) {
						return;
					}

					const pinSection = root.querySelector( '[data-tsw-pin-section]' );
					const pinned = root.querySelector( '[data-tsw-pinned]' );
					const second = root.querySelector( '[data-tsw-second]' );
					const secondReveal = root.querySelector(
						'[data-tsw-second-reveal]'
					);
					const descInner = root.querySelector(
						'[data-tsw-desc-inner]'
					);

					if ( ! pinSection || ! pinned || ! second || ! secondReveal ) {
						return;
					}

					const mm = gsap.matchMedia();

					/**
					 * @param {boolean} isDesktop True for md+ (left-to-right reveal); false for mobile (bottom-to-top).
					 */
					const buildReveal = ( isDesktop ) => {
						const imageRevealDuration = 0.65;

						// Desktop: clip-path L→R on the outer layer.
						// Mobile: bottom-anchored strip height 0%→100% (see render.php) so the image
						// is never scaled — avoids scaleY "smush" and avoids scrubbed vertical inset()
						// quirks on some WebKit builds.
						const desktopFromVars = { clipPath: 'inset(0 100% 0 0)' };
						const desktopToVars = {
							clipPath: 'inset(0 0% 0 0)',
							ease: 'none',
							duration: imageRevealDuration,
						};
						const mobileFromVars = { height: '0%' };
						const mobileToVars = {
							height: '100%',
							ease: 'none',
							duration: imageRevealDuration,
						};

						if ( isDesktop ) {
							gsap.set( secondReveal, { height: '100%' } );
						} else {
							gsap.set( secondReveal, { height: '0%' } );
						}

						const descStart = imageRevealDuration;
						const descDuration = 0.38;
						const scrollEndMultiplier = descInner ? 2.15 : 1.6;

						const descMetrics = { slidePx: 0 };

						if ( descInner ) {
							descMetrics.slidePx = measureDescSlidePx( descInner );
						}

						const syncPinSectionHeight = () => {
							const scrollPx = Math.round(
								window.innerHeight * scrollEndMultiplier
							);
							pinSection.style.minHeight = `calc(100svh + ${ scrollPx }px)`;
						};

						syncPinSectionHeight();

						const onScrollTriggerRefresh = () => {
							syncPinSectionHeight();
							if ( descInner ) {
								descMetrics.slidePx = measureDescSlidePx( descInner );
							}
						};

						const tlInstance = gsap.timeline( {
							scrollTrigger: {
								trigger: pinSection,
								start: 'top top',
								end: () =>
									`+=${ Math.round( window.innerHeight * scrollEndMultiplier ) }`,
								scrub: 0.45,
								pin: pinned,
								pinSpacing: true,
								invalidateOnRefresh: true,
								onRefresh: onScrollTriggerRefresh,
							},
						} );

						if ( isDesktop ) {
							tlInstance.fromTo(
								second,
								desktopFromVars,
								desktopToVars,
								0
							);
						} else {
							tlInstance.fromTo(
								secondReveal,
								mobileFromVars,
								mobileToVars,
								0
							);
						}

						if ( descInner ) {
							tlInstance.to(
								descInner,
								{
									opacity: 0,
									y: 0,
									duration: descStart,
									ease: 'none',
								},
								0
							);
							tlInstance.fromTo(
								descInner,
								{
									opacity: 1,
									y: () => descMetrics.slidePx,
								},
								{
									opacity: 1,
									y: 0,
									ease: 'none',
									duration: descDuration,
								},
								descStart
							);
						}
					};

					mm.add( '(min-width: 768px)', () => buildReveal( true ) );
					mm.add( '(max-width: 767.98px)', () => buildReveal( false ) );
				} );
			}
		);
	}
);
